function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import Select from 'components/Form/Select';
import FormContainerAbstract from 'components/FormContainerAbstract';
import App from 'modules/App';
import * as actions from '../../../actions';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
import * as constants from '../../../constants';
import validatorRules from './validatorRules.json';
import styles from './AddCountryForm.pcss';
class AddCountryForm extends FormContainerAbstract {
    get languageOptions() {
        return this.props.languageOptions.sort((a, b)=>{
            if (a.englishName > b.englishName) {
                return 1;
            }
            return -1;
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("p", {
                className: "mb-6",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.addNewCountry))
            })
        });
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "reset",
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.cancel,
                        className: "btn--block",
                        isInProgress: this.props.isInProgress,
                        onClick: this.props.onClose
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        styleModifier: "primary",
                        labelMessage: messages.buttons.addCountry,
                        className: "btn--block btn--filled",
                        isDisabled: this.isDisabled,
                        isInProgress: this.props.isInProgress
                    })
                })
            ]
        });
    }
    renderForm() {
        return /*#__PURE__*/ _jsxs(Form, {
            className: styles.addCountryForm,
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx(FormGroup, {
                            id: "countryName",
                            className: "col-6",
                            labelMessage: messages.labels.countryName,
                            formValues: this.props.formValues,
                            children: /*#__PURE__*/ _jsx(Input, {
                                placeholder: messages.placeholders.countryName,
                                onChange: (input)=>this.onSetValue(input)
                            })
                        }),
                        /*#__PURE__*/ _jsx(FormGroup, {
                            id: "language",
                            className: "col-6",
                            labelMessage: messages.labels.language,
                            formValues: this.props.formValues,
                            children: /*#__PURE__*/ _jsx(Select, {
                                optionsFrom: this.languageOptions,
                                valueKey: "code",
                                labelKey: "englishName",
                                noValueMessage: messages.placeholders.language,
                                onChange: (input)=>this.onSetValue(input)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row mb-6",
                    children: /*#__PURE__*/ _jsx(FormGroup, {
                        id: "countryCode",
                        className: "col-6",
                        labelMessage: messages.labels.countryCode,
                        formValues: this.props.formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            placeholder: messages.placeholders.countryCode,
                            onChange: (input)=>this.onSetValue(input)
                        })
                    })
                }),
                this.renderActions()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderHeader(),
                this.renderForm()
            ]
        });
    }
    constructor(props){
        super(props);
        this.validatorRules = _object_spread({}, validatorRules);
    }
}
_define_property(AddCountryForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    languageOptions: PropTypes.arrayOf(shapes.language),
    // Explicit actions
    onClose: PropTypes.func
}));
const mapStateToProps = (state)=>({
        formValues: App.selectors.formSelector(constants.ADD_COUNTRY_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.ADD_COUNTRY_FORM;
    return {
        onSubmit: (values)=>dispatch(actions.addCountry(values)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedAddCountryForm = connect(mapStateToProps, mapDispatchToProps)(AddCountryForm);
export default withStyles(styles)(ConnectedAddCountryForm);
